
























// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';

import { listFactory } from '@/main/pages';
import { getSearchButtonLabel, isMultipleWorkshopSelected, handleMultiWorkshopFilter, getCurrentLanguageId, validateDateFields } from '@/main/utils/commonFunctions';

import { NAME, ACCOUNT_RECIEVABLE } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';


export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			parameters: "" as string,
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		// eslint-disable-next-line consistent-return
		updateWorkShopId() {
			const result = {} as any;
			this.dropdownList.OrganizationId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
			if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0)	{
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
				return false;
			}
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				ACCOUNT_RECIEVABLE,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					DateFrom: this.DateFrom,
					DateTo: this.DateTo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('GREATER_DATE_VALIDATION'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					this.DateTo = null;
					return false;
				}
			} else {
				return false;
			}
		},
		GetParameters(WorkshopIds : any, fromDate : any, toDate : any) {
			this.parameters = `DateFrom=${new Date(fromDate!).toISOString()}&DateTo=${new Date(toDate).toISOString()}`;
			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((WorkshopId: any) => {
					this.parameters = this.parameters.concat(`&WorkshopIds=${WorkshopId}`);
				});
			}

			return this.parameters;
		},
		async exportFun() {
			try {
                if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('WareHouseIdCanNotBeNull'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				} else {
					const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
					this.startLoading();
					const urlParameters: string = this.GetParameters(this.WorkshopIds, this.DateFrom, this.DateTo);
					
					if (this.isMultipleWorkshopSelected) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
						});
					} else {
						await apiProvider.GetAccountReceivable(urlParameters, columnsSeq, getCurrentLanguageId((this.loggedUser.UzivatelData.LanguageId)));
					}
				}
			} finally {
				this.endLoading();
			}
		},
	},

	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
